import {Component, Input, OnInit} from '@angular/core';
import {PatternRepository} from '../../../../repositories/pattern.repository';
import SewingPatternInterface from '../../../../models/sewing-pattern.interface';

@Component({
  selector: 'app-pattern-list',
  templateUrl: './pattern-list.component.html',
  styleUrls: ['./pattern-list.component.css'],
})
export class PatternListComponent {

  @Input() patterns: SewingPatternInterface[] = [];
}
